import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapperMyDashboard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    wrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    statusWrapper: {
        width: "150px",
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        "&::first-letter": {
            textTransform: "capitalize",
        },
    },
    statusBadge: {
        marginTop: "1.5px !important",
    },
}));
